import * as React from "react";
function useAsyncState(initialState, fn, dependencyList) {
  const [result, setResult] = React.useState(initialState);
  const [error, setError] = React.useState();
  React.useEffect(
    () => {
      let isMounted = true;
      fn().then((result2) => {
        if (!isMounted) return;
        setResult(result2);
      }).catch((error2) => {
        if (!isMounted) return;
        setError(error2);
      });
      return () => {
        isMounted = false;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencyList
  );
  return { result, error };
}
export {
  useAsyncState
};
//# sourceMappingURL=use-async-state.js.map
